import { render, staticRenderFns } from "./GestionEvaluacionAspectos.vue?vue&type=template&id=548c9bac&"
import script from "./GestionEvaluacionAspectos.vue?vue&type=script&lang=js&"
export * from "./GestionEvaluacionAspectos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports